import i18n from '@/vue/languages';
import { getSafeInstancesProp } from '@/vue/helpers/handleInstallationsValues';

export class InstallationTank {
    constructor({ tl, tf, tcn }, instanceId = null) {
        this.tl = tl;
        this.tf = tf;
        this.tcn = tcn;
        this.instanceId = instanceId;
    }

    get name() {
        const name =
            getSafeInstancesProp(this.tcn, this.instanceId, '', 'formattedValue').trim() ||
            getSafeInstancesProp(this.tf, this.instanceId, '', 'formattedValue').trim() ||
            i18n.t('installationoverview.tank_unnamed', { i18nFallback: 'Unnamed' });
        return name;
    }

    get type() {
        return getSafeInstancesProp(this.tf, this.instanceId, '');
    }

    get level() {
        return Math.round(getSafeInstancesProp(this.tl, this.instanceId, 0));
    }

    get hasWarning() {
        if (this.type === '2' || this.type === '5') {
            return this.level >= 100;
        } else {
            return this.level <= 0;
        }
    }

    get isFuelTank() {
        return this.type === '0';
    }
}
